import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Admin1Dashboard from './components/Admin1/Dashboard';
import Admin2Dashboard from './components/Admin2/Dashboard';
import Admin3Dashboard from './components/Admin3/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import Unauthorized from './components/Unauthorized'; // Unauthorized component import karein
import 'bootstrap/dist/css/bootstrap.min.css';
import FirebaseNotification from "./components/firebaseNotifications";
const App = () => {
  return (
    <Router>
       <FirebaseNotification />
      <Routes>
        {/* Login Route */}
        <Route path="/" element={<Login />} />

        {/* Protected Admin Panel Routes */}
        <Route
          path="/admin1/*"
          element={
            <PrivateRoute allowedRole="SuperAdmin">
              <Admin1Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin2/*"
          element={
            <PrivateRoute allowedRole="Organization">
              <Admin2Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin3/*"
          element={
            <PrivateRoute allowedRole="Guardian">
              <Admin3Dashboard />
            </PrivateRoute>
          }
        />

        {/* Unauthorized Access Route */}
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </Router>
  );
};

export default App;
